var _defs, _rect, _rect2, _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoStacked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    width: 1080,
    height: 1080,
    role: "img",
    "aria-label": "IMMO INTEREST \\u2014 Real Estate",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tshadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 22,
    stdDev: 34,
    floodColor: "#142878",
    floodOpacity: 0.22
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 232,
    width: 300,
    height: 300,
    rx: 80,
    fill: "#2F5BFF",
    filter: "url(#tshadow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 567.9,
    y: 316.9,
    width: 14.88,
    height: 48.36,
    rx: 2.98,
    fill: "#FF6A2B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(447,289) scale(1.86)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 54 L50 24 L84 54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 50 V80 H72 V50"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 700,
    textAnchor: "middle",
    fontFamily: "PJS, 'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 800,
    fontSize: 128,
    letterSpacing: 1
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#0B1020"
  }, "IMMO"), /*#__PURE__*/React.createElement("tspan", {
    dx: 34,
    fill: "#FF6A2B"
  }, "INTEREST"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 556,
    y: 772,
    textAnchor: "middle",
    fontFamily: "PJS, 'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: 34,
    letterSpacing: 15,
    fill: "#99A1B3"
  }, "REAL ESTATE")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStacked);
export default __webpack_public_path__ + "static/media/logo-stacked.8920c62b5faaf7a89e226d33ff848a2e.svg";
export { ForwardRef as ReactComponent };